import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setItemArchiveItem = (state, characteristicId, archiveItem) => {
    const item = state.items.find((s) => s.id === characteristicId);
    item.is_archive = archiveItem;
};

const state = () => ({
    items: [],
});

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    putNewItem(state, item) {
        state.items.unshift(item);
    },
    updateItem(state, characteristicData) {
        const item = state.items.find((s) => s.id === characteristicData.id);
        Object.keys(item).forEach((key) => {
            item[key] = characteristicData[key];
        });
    },
    deleteItem(state, characteristicId) {
        state.items = state.items.filter((s) => s.id !== characteristicId);
    },
    moveItemToArchive(state, characteristicId) {
        setItemArchiveItem(state, characteristicId, ARCHIVED);
    },
    moveItemFromArchive(state, characteristicId) {
        setItemArchiveItem(state, characteristicId, NOT_ARCHIVED);
    },
};

const actions = {
    async fetchItems({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/index&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setItems", data);
    },
    async createItem({ rootState, commit }, characteristicData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/create`, token);

        const { data } = await axios.post(url, characteristicData);

        if (data.success) {
            commit("putNewItem", data.model);
        }

        return data;
    },
    async updateItem({ rootState, commit }, characteristicData) {
        const token = rootState.authToken;
        const characteristicId = characteristicData.id;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/update&id=${characteristicId}`, token);

        const { data } = await axios.put(url, characteristicData);

        if (data.success) {
            commit("updateItem", data.model);
        }

        return data;
    },
    async deleteItem({ rootState, commit }, characteristicId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/delete&id=${characteristicId}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteItem", characteristicId);
        }
    },
    async moveItemToArchive({ rootState, commit }, characteristicId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/archive&id=${characteristicId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveItemToArchive", characteristicId);
        }
        return data.success;
    },
    async moveItemFromArchive({ rootState, commit }, characteristicId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/archive&id=${characteristicId}&is_archive=0`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveItemFromArchive", characteristicId);
        }

        return data.success;
    },
    async updateSort({ rootState, state }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/worker-type/update-sort`, token);

        const sortingData = state.items.map((s, sIndex) => ({ id: s.id, sort: state.items.length - sIndex }));

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
